import { render, staticRenderFns } from "./LegalPage.vue?vue&type=template&id=03b1c56e"
import script from "./LegalPage.vue?vue&type=script&lang=js"
export * from "./LegalPage.vue?vue&type=script&lang=js"
import style0 from "./LegalPage.vue?vue&type=style&index=0&id=03b1c56e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports